import * as React from "react";
function SvgLink(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M26.5 30.7c-1 0-2-.2-2.8-.5l-2-.8c-.8-.3-1.1-1.3-.8-2.1s1.1-1.1 2-.8l2 .8c1.6.7 3.3.3 3.6-.7L36 8.2c.3-1-.7-2.4-2.1-3.1l-4.1-1.6c-1.6-.7-3.3-.3-3.6.7L22.3 14c-.3.8-1.3 1.1-2.1.8-.8-.3-1.1-1.1-.8-2L23.3 3C24.4.2 28-.7 31.3.6l4.1 1.6c3.3 1.3 5.1 4.6 3.9 7.3L31.7 28c-.9 1.6-3.1 2.9-5.2 2.7zM19.7 48c-1 0-2-.2-2.9-.7l-4.1-1.6c-3.3-1.3-5.1-4.6-3.9-7.2L16 20.7c1.1-2.6 4.6-3.7 7.8-2.4l2 .8c.8.5 1 1.5.5 2.3-.3.5-1 .8-1.6.7l-2-.8c-1.6-.7-3.3-.2-3.6.7l-7.2 17.8c-.3.8.5 2.3 2.3 2.9l4.1 1.6c.8.3 1.6.5 2.4.3.5-.2.8-.3 1.1-.8l3.6-9c.3-.8 1.1-1.3 2.1-1 1 .3 1.3 1.1 1 2.1v.2l-3.9 9c-.7 1.3-1.8 2.4-3.3 2.8-.5.1-1.1.1-1.6.1z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgLink);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
